export default "__VITE_ASSET__Dm33h$Cy__"